<template>
  <b-col md="6">
    <form-group :validations="validation">
      <div slot-scope="{ errors, invalid }">
        <b-alert show class="overflow_div">
          <b-form-group :class="{ invalid }">
            <label
            >زبان
               
            </label>

            <div v-for="item in languages">
              <input
                  type="radio"
                  :value="item.id"
                  :id="`language_item_${item.id}`"
                  @input="updateValue"
                  :class="{ invalid }"
                  name="language"
              />
              <label class="mr-1" :for="`language_item_${item.id}`">{{
                  item.name
                }}</label>
            </div>

            {{ selectedItem }}
          </b-form-group>
        </b-alert>
        <form-errors-manager :errors="errors"/>
      </div>
    </form-group>
  </b-col>
</template>

<script>
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {required} from "vuelidate/lib/validators";
import {mapGetters} from "vuex";

export default {
  name: "LanguageBox",
  props: {
    validation: {},
    selectedItem: {}
  },
  components: {FormGroup, FormErrorsManager},
  computed: {
    ...mapGetters({
      languages: "Language/getLanguages"
    })
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
    },
    refreshLanguages() {
      this.$store.dispatch('Language/getLanguages')
    }
  }
}
</script>

<style scoped>
.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>